import React from "react"
import { twMerge } from "tailwind-merge"
import { useStaticQuery, graphql } from "gatsby"

const Pill = props => {
  return (
    <span
      className={twMerge([
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium leading-4",
        props.color,
      ])}
    >
      {props.children}
    </span>
  )
}

const ResourcePill = props => {
  const pill =
    props.text === "pdf"
      ? `PDF`
      : props.text === "mp4"
        ? `Video`
        : props.text === "page"
          ? `Web Page`
          : `Application Note`
  const color =
    props.text === "pdf"
      ? "bg-rose-100 text-rose-800"
      : props.text === "mp4"
        ? "bg-emerald-100 text-emerald-800"
        : props.text === "page"
          ? "bg-blue-100 text-blue-800"
          : "bg-slate-100 text-slate-800"
  return <Pill color={color}>{pill}</Pill>
}

const TypePill = props => {
  const pill =
    props.type === "APPNOTE"
      ? `Application Note`
      : props.type === "PW"
        ? `Published Work`
        : props.type === "GI"
          ? `General Information`
          : props.type === "VIDEO"
            ? `Video`
            : props.type === "CAT"
              ? `Brochure`
              : `General`
  const color =
    props.type === "APPNOTE"
      ? "bg-emerald-100 text-emerald-800"
      : props.type === "PW"
        ? "bg-blue-100 text-blue-800"
        : props.type === "GI"
          ? "bg-slate-100 text-slate-800"
          : props.type === "VIDEO"
            ? "bg-pink-100 text-pink-800"
            : props.type === "CAT"
              ? "bg-amber-300 text-amber-800"
              : "bg-slate-100 text-slate-800"
  return <Pill color={color}>{pill}</Pill>
}

const ProductPill = props => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          brand {
            uyf
            singlestep
            og
          }
        }
      }
    }
  `)
  const pill =
    props.product === "FV"
      ? `Filter Vials`
      : props.product === "OG"
        ? `${data.site.siteMetadata.brand.og}`
        : props.product === "UYF"
          ? `${data.site.siteMetadata.brand.uyf}`
          : props.product === "wellplate"
            ? `Well Plates`
            : props.product === "columns"
              ? `${data.site.siteMetadata.brand.singlestep}`
              : `Product`
  const color =
    props.product === "FV"
      ? "bg-teal-100 text-teal-800"
      : props.product === "OG"
        ? "bg-violet-100 text-violet-800"
        : props.product === "UYF"
          ? "bg-indigo-100 text-indigo-800"
          : props.product === "wellplate"
            ? "bg-pink-100 text-pink-800"
            : props.product === "columns"
              ? "bg-blue-100 text-blue-800"
              : "bg-slate-100 text-slate-800"
  return <Pill color={color}>{pill}</Pill>
}

export { ResourcePill, TypePill, ProductPill }
